import React, { JSX } from 'react';
import { Link, LinkProps } from '../Link/Link';
import { hasValue } from '@r-and-a-shared-ui/utils';

type WithOrWithoutLinkProps = {
  url?: LinkProps;
  children: JSX.Element | JSX.Element[] | React.ReactNode;
};

export const WithOrWithoutLink = ({
  url,
  children,
}: WithOrWithoutLinkProps) => {
  if (url && (hasValue(url.href) || hasValue(url.codename))) {
    return <Link {...url}>{children}</Link>;
  }

  return children;
};
